import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Camera } from 'lucide-react';
import iconLogo from './assets/icon.png';

const Header = () => {
    const location = useLocation();

    return (
        <header style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            background: 'rgba(23, 27, 39, 0.95)',
            backdropFilter: 'blur(10px)',
            borderBottom: '1px solid #30374A',
            padding: '1rem 2rem'
        }}>
            <nav style={{
                maxWidth: '1200px',
                margin: '0 auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                {/* Logo */}
                <Link
                    to="/"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.75rem',
                        textDecoration: 'none',
                        transition: 'opacity 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
                    onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                >
                    <img
                        src={iconLogo}
                        alt="VolleyScout Logo"
                        style={{
                            width: '40px',
                            height: '40px',
                            objectFit: 'contain'
                        }}
                    />
                    <span style={{
                        fontSize: '1.5rem',
                        fontWeight: '800',
                        color: '#007AFF'
                    }}>VolleyScout</span>
                </Link>

                {/* Navigation Links */}
                <div style={{
                    display: 'flex',
                    gap: '2rem',
                    alignItems: 'center'
                }}>
                    <Link
                        to="/"
                        style={{
                            color: location.pathname === '/' ? '#007AFF' : '#edfaff',
                            textDecoration: 'none',
                            fontSize: '1rem',
                            fontWeight: '600',
                            transition: 'color 0.3s ease',
                            position: 'relative'
                        }}
                        onMouseEnter={(e) => {
                            if (location.pathname !== '/') {
                                e.currentTarget.style.color = '#007AFF';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (location.pathname !== '/') {
                                e.currentTarget.style.color = '#edfaff';
                            }
                        }}
                    >
                        Start
                    </Link>
                    <Link
                        to="/support"
                        style={{
                            color: location.pathname === '/support' ? '#007AFF' : '#edfaff',
                            textDecoration: 'none',
                            fontSize: '1rem',
                            fontWeight: '600',
                            transition: 'color 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            if (location.pathname !== '/support') {
                                e.currentTarget.style.color = '#007AFF';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (location.pathname !== '/support') {
                                e.currentTarget.style.color = '#edfaff';
                            }
                        }}
                    >
                        Support
                    </Link>
                </div>
            </nav>
        </header>
    );
};

export default Header;